import { call, put } from 'redux-saga/effects';
import { fetchReportDataComplete } from '../../api/strapiGop';
import { FetchReportDataRequestAction } from '../../types/types';
import { fetchReportDataFailure, fetchReportDataSuccess } from './actions';

export function* fetchReportDataSaga(action: FetchReportDataRequestAction) {
  try {
    const { filters } = action.payload;
    const reportData: { answers: any[]; statuses: any[] } = yield call(fetchReportDataComplete, filters);
    yield put(fetchReportDataSuccess(reportData.answers, reportData.statuses));
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при загрузке данных отчета';
    yield put(fetchReportDataFailure(errorMessage));
  }
}
